import React from 'react';
import classnames from 'classnames';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.grey[400]
  },
  error: {
    color: theme.palette.error.medium
  }
}));

interface LengthCounterProps {
  maxLength: number
  currentLength: number
}

export const LengthCounter = ({ maxLength, currentLength }: LengthCounterProps) => {
  const classes = useStyles();

  return (
    <div
      className={classnames(
        classes.root,
        currentLength >= maxLength && classes.error
      )}
    >
      {currentLength} / {maxLength}
    </div>
  );
};

export default LengthCounter;
